import { Box } from "@mui/material"
import { useSelector } from "react-redux"
import { AppState } from "../../core/app/AppReducer"
import { DungeonsKeysList } from "./DungeonsKeysData"
import DungeonKeysTracking from "./DungeonsKeysTracking"


const KeysanityTracking = () => {

    let keysanity = useSelector((state: AppState) => state.ui.ootr.main.isKeysanity)
    if (!keysanity)
        return null;

    return <Box display={"flex"} flexDirection={"row"} maxHeight={"175px"} margin={"5px"}>
        {DungeonsKeysList.map((k, i) => {

            return <DungeonKeysTracking dungeon={k} id={i + ""} />
        })}
    </Box>
}

export default KeysanityTracking